import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useTenant } from '../contexts/TenantContext';
import tenantService from '../services/tenantService';

const TenantSelector = () => {
  const [tenants, setTenants] = useState([]);
  const [selectedTenantId, setSelectedTenantId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { selectTenant } = useTenant();

  useEffect(() => {
    loadTenants();
  }, []);

  const loadTenants = async () => {
    try {
      const tenantsData = await tenantService.getTenants();
      setTenants(tenantsData);
    } catch (err) {
      setError('Error cargando tenants');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedTenantId) return;

    try {
      setLoading(true);
      const tenant = await tenantService.selectTenant(selectedTenantId);
      selectTenant(tenant);
    } catch (err) {
      setError('Error seleccionando tenant');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 d-flex align-items-center bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <Card className="shadow">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <i className="bi bi-building fs-1 text-primary mb-3"></i>
                  <h2 className="h4 mb-2">Seleccionar Institución</h2>
                  <p className="text-muted">Elige la institución para continuar</p>
                </div>
                
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Select
                      value={selectedTenantId}
                      onChange={(e) => setSelectedTenantId(e.target.value)}
                      required
                    >
                      <option value="">Selecciona una institución...</option>
                      {tenants.map(tenant => (
                        <option key={tenant.id} value={tenant.id}>
                          {tenant.name} ({tenant.domain})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  {error && (
                    <Alert variant="danger" className="mb-3">
                      {error}
                    </Alert>
                  )}

                  <Button 
                    type="submit" 
                    variant="primary" 
                    className="w-100"
                    disabled={loading || !selectedTenantId}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Cargando...
                      </>
                    ) : (
                      'Continuar'
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TenantSelector;